import {rupiah} from 'utils/formatter'
import styles from './Total.css'

class Total extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <div className={styles['receipt-total-box']}>
        <div className='pull-left'>Total</div>
        <div className='pull-right text-pre-wrap'>{ rupiah(this.props.total)}</div>
      </div>

      <div className={`row ${styles['receipt-cash-box']}`}>
        <div className='pull-left'>
          Cash
        </div>
        <div className='pull-right'>
          {rupiah(this.props.cash)}
        </div>
      </div>

      <div className={`row ${styles['receipt-change-box']}`}>
        <div className='pull-left'>Change</div>
        <div className='pull-right'>{rupiah(this.props.change)}</div>
      </div>
    </div>)
  }
}

Total.propTypes = {
  total: React.PropTypes.number,
  cash: React.PropTypes.number,
  change: React.PropTypes.number
}

export default Total



// WEBPACK FOOTER //
// ./app/components/receipt/previews/Total/Total.js